export default class UserEditAdminController {
  constructor($q, $rootScope, $state, $stateParams, AdministrationService, AuthenticationService, UIService, User, Investigador) {
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.Administration = AdministrationService;
    this.Authentication = AuthenticationService;
    this.UI = UIService;
    this.User = User;
    this.Investigador = Investigador;

    this.user = {
      imap: false,
      blocked: false
    };
    this.loaded = false;
    if (angular.isUndefined($stateParams.id)) {
      $state.go('app.administration.main');
    }
    this.loadUserInfo($stateParams.id);
  }

  isNotUser = () => {
    return (this.Authentication.getId() !== this.user.id);
  };

  blockUser = () => {
    let message = 'Deseja ' + ((this.user.blocked) ? 'des' : '') + 'bloquear utilizador?';
    let confirm = this.UI.showConfirm(message);
    confirm.then(() => {
      // OK
      this.user.blocked = !this.user.blocked;
      this.user.$save().then(() => {
        let messaging = 'Utilizador ' + ((!this.user.blocked) ? 'des' : '') + 'bloqueado';
        this.UI.addToast(messaging);
      }).catch(err => {
        console.log(err);
      });
    }).catch(() => {
      // Cancel
    });
  };

  removeUser = () => {
    let dialog = this.UI.showConfirm('Deseja remover utilizador do sistema?');
    dialog.then(() => {
      this.Administration.removeUser(this.user).then((result) => {
        this.UI.addToast('Utilizador removido');
        this.$state.go('app.administration.main');
      });
    });
  };

  loadUserInfo = (id) => {
    this.loaded = false;
    this.Administration.getUser(id).then((user) => {
      this.Investigador.find({
        filter: {
          where: {
            userId: user.id
          }
        }
      }).$promise.then((investigador) => {
        this.user = user;
        this.user.investigador = investigador[0];
        this.loaded = true;
      }).catch((error) => {
        this.user = user;
        if (error.status !== 404) {
          console.log(error);
          this.UI.addToast('Erro ao carregar dados');
          this.$state.go('app.administration.main');
        }
        this.loaded = true;
      });
    }).catch(error => {
      console.log(error);
      this.UI.addToast('Erro ao carregar dados');
      this.$state.go('app.administration.main');
    });
  };

  // Form for user password change
  changePassword = () => {
    let options = {
      template: require("./change-password.html"),
      controller: ["$scope", "$dialog", ($scope, $dialog) => {
        $scope.ok = () => {
          $scope.$close($scope);
        };
        $scope.cancel = () => {
          $dialog.dismiss();
        };
      }]
    };
    this.UI.showDialog(options).then(ok => {
      let wait = this.UI.showWaiting();
      this.Administration.changePassword(this.user.id, ok.newPassword).then(() => {
        wait.close();
        this.UI.addToast("Password alterada");
      }).catch((err) => {
        wait.close();
        console.log(err);
        this.UI.showAlert("Erro na alteração de password. Verifique se tem permissões e/ou verifique a ligação");
      });
    }).catch(() => { });
  };

  editUser = () => {
    let wait = this.UI.showWaiting();
    let orFilter = [{userId: null}];
    if (this.user.investigador)
      orFilter.push({userId: this.user.id});
    // Find all investigadores that are unassigned (or assigned to this user)
    this.Investigador.find({
      filter: {
        where: {
          or: orFilter
        }
      }
    }).$promise.then((investigadores) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./properties.dialog.html'),
        controller: ['$scope', '$dialog', (scope, dialog) => {
          scope.user = angular.copy(this.user);
          scope.investigadores = investigadores;

          scope.auxInvestigador = {
            selected: scope.user.investigador ? scope.user.investigador : null,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.isNotUser = () => {
            return this.isNotUser();
          };

          scope.isInvalid = () => {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return (scope.user.name.length === 0 || !re.test(scope.user.email.toLowerCase()));
          };

          scope.cancel = () => {
            scope.$dismiss();
          };

          scope.ok = () => {
            dialog.close(scope);
          };
        }]
      };

      let dialog = this.UI.showDialog(options);
      dialog.then(ok => {
        wait = this.UI.showWaiting();
        if (ok) {
          this.User.find({
            filter: {
              where: {
                and: [{ id: { neq: this.user.id } }, { email: ok.user.email }]
              }
            }
          }).$promise.then((users) => {
            if (users && users.length > 0) { // Already exists user with email
              this.UI.addToast("Email já existente na base de dados.");
              wait.close();
            } else { // No email found, change it
              this.User.upsert(ok.user).$promise.then(user => {

                // Investigador is selected
                if (ok.auxInvestigador.selected && ok.auxInvestigador.selected.id > 0) {
                  // Attempt to find other investigadores that have this investigador assigned
                  this.Investigador.find({
                    filter: {
                      where: {
                        userId: user.id
                      }
                    }
                  }).$promise.then((investigadoresUsers) => {
                    // Found investigador for this user, check if it's this user or not
                    if (investigadoresUsers && investigadoresUsers.length > 0) {
                      if (this.user.investigador) {
                        if (investigadoresUsers[0].id === ok.auxInvestigador.selected.id) {
                          // Do nothing, as it's already assigned
                          wait.close();
                          this.loadUserInfo(this.user.id);
                        } else {
                          // Change the user of investigador to another
                          this.assignInvestigadorUser(investigadoresUsers[0], null).then((x) => {
                            this.assignInvestigadorUser(ok.auxInvestigador.selected, this.user.id).then((x) => {
                              wait.close();
                              this.UI.addToast("Atribuição de Investigador alterada.");
                              this.loadUserInfo(this.user.id);
                            }).catch(error => {
                              console.log(error);
                            });
                          }).catch(error => {
                            console.log(error);
                          });
                        }
                      } else { // User does not have investigador, but we found the user for this investigador(?), deny it
                        this.UI.addToast("Investigador já está atribuído a este perfil.");
                        wait.close();
                        this.loadUserInfo(this.user.id);
                      }
                    } else { // No investigador was found for user
                      // Check if investigador is assigned to someone else already
                      this.Investigador.find({
                        filter: {
                          where: {
                            and: [{id: ok.auxInvestigador.selected.id}, {userId: {neq: null}}]
                          }
                        }
                      }).$promise.then((otherInvestigadores) => {
                        if (otherInvestigadores && otherInvestigadores.length > 0) { // Already assigned, skip
                          this.UI.addToast("Investigador já está atribuído a outro perfil.");
                          wait.close();
                          this.loadUserInfo(this.user.id);
                        } else { // Assign investigador to user since there wasn't one before
                          this.assignInvestigadorUser(ok.auxInvestigador.selected, this.user.id).then((x) => {
                            this.loadUserInfo(this.user.id);
                            wait.close();
                          }).catch(error => {
                            console.log(error);
                          });
                        }
                      }).catch((error) => {
                        console.log(error);
                      });
                    }
                  }).catch((error) => {
                    console.log(error);
                  });
                } else { // Investigador was unselected, remove connection (if exists)
                  this.assignInvestigadorUser(this.user.investigador, null).then((x) => {
                    wait.close();
                    this.UI.addToast("Removida atribuição de Investigador.");
                    this.loadUserInfo(this.user.id);
                  }).catch(error => {
                    console.log(error);
                  });
                }
              }).catch((error) => {
                console.log(error);
                this.UI.addToast("Não foi possível gravar informação de utilizador. Verifique a ligação");
              });
            }
          }).catch((error) => {
            console.log(error);
            this.UI.addToast("Não foi possível encontrar utilizador.");
          });
        }
      }).catch(() => { });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível consultar investigadores. Verifique a ligação");
    });
  };

  // Assign userId to investigador object and save it
  assignInvestigadorUser = (investigador, userId) => {
    let defer = this.$q.defer();
    investigador.userId = userId;
    this.Investigador.upsert(investigador).$promise.then((res) => {
      defer.resolve(res);
    }).catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };

}

UserEditAdminController.$inject = ['$q', '$rootScope', '$state', '$stateParams', 'AdministrationService', 'AuthenticationService', 'UIService', 'User', 'Investigador'];
